/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { MeControllerGetUserTPromptsQueryResponse, MeControllerGetUserTPrompts400, MeControllerGetUserTPrompts401, MeControllerGetUserTPrompts404, MeControllerGetUserTPrompts409, MeControllerGetUserTPrompts500 } from "../types/MeControllerGetUserTPrompts.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getMeControllerGetUserTPromptsUrl() {
  const res = { method: 'GET', url: `/api/me/tprompts` as const }
  return res
}

/**
 * @description Retrieves the list of available TPrompts for the current user.
 * @summary Get user's TPrompts
 * {@link /api/me/tprompts}
 */
export async function meControllerGetUserTPrompts(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<MeControllerGetUserTPromptsQueryResponse, ResponseErrorConfig<MeControllerGetUserTPrompts400 | MeControllerGetUserTPrompts401 | MeControllerGetUserTPrompts404 | MeControllerGetUserTPrompts409 | MeControllerGetUserTPrompts500>, unknown>({ method : "GET", url : getMeControllerGetUserTPromptsUrl().url.toString(), ... requestConfig })
  return res.data
}